import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Question",
  "use": "Question-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"Question\">\n  <path fill=\"currentColor\" d=\"M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16 16-7.2 16-16S24.8 0 16 0zm1.6 27.2h-3.2V24h3.2v3.2zm3.3-12.4l-1.4 1.5c-1.2 1.2-1.9 2.1-1.9 4.5h-3.2V20c0-1.8.7-3.4 1.9-4.5l2-2c.6-.6.9-1.4.9-2.3C19.2 9.4 17.8 8 16 8s-3.2 1.4-3.2 3.2H9.6c0-3.5 2.9-6.4 6.4-6.4s6.4 2.9 6.4 6.4c0 1.4-.6 2.7-1.5 3.6z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol